/**
 * HTTP layer for product-inventory movement logs. The audit trail of stock
 * adjustments.
 *
 * Contains:
 * - fetchProductInventoryLogs / fetchProductInventoryLog: reads
 * - postProductInventoryLog / patchProductInventoryLog / deleteProductInventoryLog: writes
 */
import apiClient from '@sophocles/http-common';

const PRODUCT_INVENTORY_LOG_ENDPOINT = '/warehouse/product-inventory-logs';

export const fetchProductInventoryLogs = queryParams =>
  apiClient.get(`${PRODUCT_INVENTORY_LOG_ENDPOINT}/`, { params: queryParams }).then(res => res.data);

export const fetchProductInventoryLog = productInventoryLogId =>
  apiClient.get(`${PRODUCT_INVENTORY_LOG_ENDPOINT}/${productInventoryLogId}/`).then(res => res.data);

export const postProductInventoryLog = data =>
  apiClient.post(`${PRODUCT_INVENTORY_LOG_ENDPOINT}/`, data).then(res => res.data);

export const patchProductInventoryLog = (productInventoryLogId, data) =>
  apiClient.patch(`${PRODUCT_INVENTORY_LOG_ENDPOINT}/${productInventoryLogId}/`, data).then(res => res.data);

export const deleteProductInventoryLog = productInventoryLogId =>
  apiClient.delete(`${PRODUCT_INVENTORY_LOG_ENDPOINT}/${productInventoryLogId}/`);
